import emailjs from '@emailjs/browser'
import type { EmailJSConfig } from '../types/contact'

// EmailJS configuration from environment variables
export const emailJSConfig: EmailJSConfig = {
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || '',
  templateId: import.meta.env.VITE_EMAILJS_TEMPLATE_ID || '',
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || ''
}

// EmailJS service class
export class EmailJSService {
  private static instance: EmailJSService
  private isInitialized = false

  private constructor() { }

  public static getInstance(): EmailJSService {
    if (!EmailJSService.instance) {
      EmailJSService.instance = new EmailJSService()
    }
    return EmailJSService.instance
  }

  public async initialize(): Promise<void> {
    if (this.isInitialized) return

    try {
      // Validate configuration
      if (!emailJSConfig.serviceId || !emailJSConfig.templateId || !emailJSConfig.publicKey) {
        throw new Error('EmailJS configuration is missing. Please check your environment variables.')
      }

      // Initialize EmailJS with public key
      emailjs.init(emailJSConfig.publicKey)
      
      console.log('EmailJS service initialized successfully')
      this.isInitialized = true
    } catch (error) {
      console.error('Failed to initialize EmailJS:', error)
      throw new Error('Failed to initialize email service')
    }
  }

  public async sendEmail(
    templateParams: Record<string, unknown>
  ): Promise<{ success: boolean; message: string }> {
    try {
      if (!this.isInitialized) {
        await this.initialize()
      }

      // Send email using EmailJS
      const response = await emailjs.send(
        emailJSConfig.serviceId,
        emailJSConfig.templateId,
        templateParams,
        emailJSConfig.publicKey
      )

      console.log('Email sent successfully:', response)

      return {
        success: true,
        message: 'Message sent successfully! I\'ll get back to you soon.'
      }

    } catch (error) {
      console.error('EmailJS send error:', error)

      // Provide user-friendly error message
      let errorMessage = 'Failed to send message. Please try again or contact me directly at abrahammgag@gmail.com'
      
      if (error instanceof Error) {
        // Check for common EmailJS errors
        if (error.message.includes('publicKey')) {
          errorMessage = 'Email service configuration error. Please contact the site administrator.'
        } else if (error.message.includes('network')) {
          errorMessage = 'Network error. Please check your connection and try again.'
        }
      }

      return {
        success: false,
        message: errorMessage
      }
    }
  }
}

// Utility function for easy access
export const emailService = EmailJSService.getInstance()
